import { useQuery } from "@tanstack/react-query";
import { apisiseci } from "../api";
import { DefaultFilter } from "../../@types/filter";
import { AttendanceUsers } from "../../@types/attendance-local-user";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
    unidade?: string;
};

type AttendanceUsersResponse = AttendanceUsers[];

export function useUserList(params?: Props) {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<AttendanceUsersResponse, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ["user", "list", params],
        queryFn: async () => {
            const response = await apisiseci.get<AttendanceUsersResponse>(
                "/cms/users/",
                { headers: { Authorization: `Bearer ${token}`, }, params }
            );
            return response.data;
        },
    });
}
